import {AttachmentType} from "@/models/Enums";

export default class ToolbarModel {
    public public: boolean = false;

    public types: AttachmentType[] = [];
}